module.exports = __webpack_public_path__ + "img/ba.06c220db.svg";